import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const SesHeader = ({ clientCobranding, isWarmUp }) => {
    const [brandLogo, setBrandLogo] = useState("");
    const location = useLocation();
    let phrases = location?.state?.user?.siteConfig?.phrases;
    let showWarmupText = isWarmUp ? isWarmUp : isWarmUp == false ? isWarmUp : location?.state?.warmUp;

    const getLogoUrl = (brandId) => {
        const img = new Image();
        let logVal =
            window.location.origin + "/static/Xpert_Logos/" + brandId + ".png";
        img.src = logVal;
        if (img.complete) {
            setBrandLogo(logVal);
        } else {
            img.onload = () => {
                setBrandLogo(logVal);
            };
            img.onerror = () => {
                logVal = window.location.origin + "/static/Xpert_Logos/87.png";
                setBrandLogo(logVal);
            };
        }
    };

    useEffect(() => {
        const session_data = JSON.parse(sessionStorage.getItem("session_data"))
            ?.siteConfig?.countryBrand;
        const colleagueBrandId = JSON.parse(
            sessionStorage.getItem("colleague")
        )?.brandId;
        let brandId = colleagueBrandId
            ? colleagueBrandId
            : session_data
                ? session_data.slice(3)
                : 2;
        getLogoUrl(brandId);
    }, []);

    return (
        <div className="flex g-2 justify-content_center align-items_center xpert-align-self-stretch mobile-wrap">
            <div className="flex flex_col_mobile g1">
                <img alt="adecco-logo" src={brandLogo} className="xpert-header-logo" />
                {clientCobranding && (
                    <img alt="client-logo" src={clientCobranding} className="xpert-header-logo" />
                )}
                {showWarmupText && <p className="text-02 subtitle mobile-warmup-text">{phrases?.["26000062"]}</p>}
            </div>
        </div>
    );
};

export default SesHeader;
